(function () {
    'use strict';

    angular.module('app').component('corporateBenefitGroupsCreateEditCopayComponent', {
        templateUrl: require('/App/corporate/views/benefitGroups/createEdit/copay/copay.component.html'),
        controller: controller,
        controllerAs: 'vm',
        bindings: {
            coPayExample: '<',
            showCoPayExample: '<',
            currencyCode: '<',
            benefitGroup: '<',
            isReadOnly: '<'
        }
    });

    function controller() {
        var vm = this;
    }
})();
